module.exports = __webpack_public_path__ + "img/833-89efba.png";